import React, { useEffect, useState } from "react";
import {
  AssignmentList,
  CustomTextInput,
  EmptyPopup,
  FallBack,
  Image,
  PrimaryCta,
} from "../../components";
import CustomTable from "../../components/customTable";
import { toast } from "react-toastify";
import Core from "../../common/clientSdk";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "../loader";
import Utils from "../../common/utils";
import { useSnackbar } from "react-simple-snackbar";
import { CustomText } from "../../components";
import Icon from "../../components/core_component/icon";
import exportToCSV from "../../common/exportToCSV";
import Select from "react-dropdown-select";
import campaign, * as CampaignData from "../../common/data/campaign";
import { InfluencerContractsShareLink } from "../../modal/influencercontractsShare";

const limit = 10;
function AssignmentListScreen(props) {
  const [assignmentList, setAssignmentList] = useState([]);
  const [start, setStart] = useState(0);
  const [isLoading, setLoading] = useState(true);
  const [filterDropDown, setFilterDropDown] = useState(false);
  const [influencerContractsList, setInfluencerContractsList] = useState([]);
  const [filterLabel, setFilterLabel] = useState("");
  // const [sortBy, setSortBy] = useState(null);
  // const [sortOrder, setSortOrder] = useState(null);
  // const [loading, setLoading] = useState(true);
  const [next, setNext] = useState(0);
  const [influencerPhoneNumber, setInfluencerPhoneNumber] = useState(null);
  const [influencerPhone, setInfluencerPhone] = useState(null);
  const [influencerPanNumber, setInfluencerPanNumber] = useState("");
  const [influencerAccountNumber, setInfluencerAccountNumber] = useState("");
  const [influencerConfirmAccountNumber, setInfluencerConfirmAccountNumber] =
    useState("");
  const [influencerIfscCode, setInfluencerIfscCode] = useState("");
  const [influencerPremise, setInfluencerPremise] = useState("");
  const [influencerCity, setInfluencerCity] = useState("");
  const [influencerState, setInfluencerState] = useState("");
  const [influencerPincode, setInfluencerPincode] = useState("");
  const [updateKycLoading, setUpdateKycLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState("ALL");
  const [legalName, setLegalName] = useState("");
  const [bankDataType, setBankDataType] = useState("upi");
  const [upiId, setUpiId] = useState("");
  const [modalIsOpenShare, setModalIsOpenShare] = useState(false);
  const [openSnackbar] = useSnackbar();
  const [influencerId, setInfluencerId] = useState(null);
  const [assignmentId, setAssignmentId] = useState(null);
  const [startAssignmentLoading, setStartAssignmentLoading] = useState(false);
  const [influencerKycPopupOpen, setInfluencerKycPopupOpen] = useState(false);
  const navigate = useNavigate();
  const [statusColors] = useState({
    ACTIVE: "#FABC13",
    INACTIVE: "red",
    COMPLETED: "#009A29",
    IN_REVIEW: "#1977f2",
    PAYMENT_PENDING: "#ff4500",
    CENCELLED: "#ff4500",
    IN_PROGRESS: "#059142",
  });
  const sortTypes = [
    {
      Status: "ALL",
      label: "ALL",
    },
    {
      Status: "ACTIVE",
      label: "ACTIVE",
    },
    {
      Status: "COMPLETED",
      label: "COMPLETED",
    },

    {
      Status: "IN_PROGRESS",
      label: "IN PROGRESS",
    },

    {
      Status: "CANCELLED",
      label: "CANCELLED",
    },
  ];

  useEffect(() => {
    getAssignmentUser(start, updateProgress);
  }, [filterStatus]);

  const collectionData = useParams().id;
  let params = new URLSearchParams(collectionData);
  let collectionId = params.get("collection_id");
  let collection_name = params.get("collection_name");

  function openModalShare() {
    if (modalIsOpenShare == false) {
      setModalIsOpenShare(true);
    } else {
      setModalIsOpenShare(false);
    }
  }

  function closeShareModal() {
    setModalIsOpenShare(false);
  }

  function updateProgress(status) {}

  const campaignId = props.campaignId;
  const campaignDetail = props.campaignDetail;
  const { campaign_data = {} } = campaignDetail;
  const assignment_share_key = campaign_data?.assignment_share_key;
  console.log("assignment_share_key w", assignment_share_key, campaign_data);

  function getAssignmentUser(startPage, progress_cb) {
    var params = {
      campaign_id: campaignId,
    };
    if (filterStatus != "ALL") {
      params.status = filterStatus;
    }
    Core.getAssignmentUser(
      getAssignmentUserSuccess,
      getAssignmentUserFailed,
      progress_cb,
      params,
    );
  }

  function getAssignmentUserSuccess(response_data) {
    setAssignmentList(response_data["assignment_list"]);
    setNext(response_data?.pagination_data?.next);
    setLoading(false);
  }

  function getAssignmentUserFailed(errorList) {
    openSnackbar(errorList.map((err) => err.m).join(", "));
  }

  function startAssignment(influencer_id, assignment_id) {
    const params = {
      assignment_id: assignment_id,
      influencer_id: influencer_id,
    };
    Core.startAssignment(
      startAssignmentSuccess,
      startAssignmentFailed,
      (status) => setStartAssignmentLoading(status),
      params,
    );
  }

  function startAssignmentSuccess(response_data) {
    openSnackbar("Assignment started successfully");
    setStartAssignmentLoading(false);
    getAssignmentUser(start, updateProgress);
  }

  function startAssignmentFailed(errorList) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
  }
  console.log("influencerPhone", influencerPhone);

  const validateKycForm = () => {
    if (legalName.trim().length === 0) {
      toast.error("Please enter name on PAN Number");
      return false;
    }

    // Phone (only if not already present)
    if (!influencerPhone) {
      if (!influencerPhoneNumber || influencerPhoneNumber.length !== 10) {
        toast.error("Please enter a valid 10 digit phone number");
        return false;
      }
    }

    // PAN
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panRegex.test(influencerPanNumber)) {
      toast.error("Please enter a valid PAN number");
      return false;
    }

    // Payment Type
    if (!bankDataType) {
      toast.error("Please select a payment method");
      return false;
    }

    // UPI validation
    if (bankDataType === "upi") {
      const upiRegex = /^[\w.-]+@[\w.-]+$/;
      if (!upiId || !upiRegex.test(upiId)) {
        toast.error("Please enter a valid UPI ID");
        return false;
      }
    }

    // Bank validation
    if (bankDataType === "bank") {
      if (!influencerAccountNumber) {
        toast.error("Please enter account number");
        return false;
      }

      if (influencerAccountNumber !== influencerConfirmAccountNumber) {
        toast.error("Account number and confirm account number do not match");
        return false;
      }

      const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      if (!ifscRegex.test(influencerIfscCode)) {
        toast.error("Please enter a valid IFSC code");
        return false;
      }
    }

    // Address fields
    if (!influencerPremise) {
      toast.error("Please enter premise");
      return false;
    }

    if (!influencerCity) {
      toast.error("Please select city");
      return false;
    }

    if (!influencerState) {
      toast.error("Please select state");
      return false;
    }

    if (!influencerPincode || influencerPincode.length !== 6) {
      toast.error("Please enter a valid 6 digit pincode");
      return false;
    }

    return true;
  };

  function verifyKycAuto() {
    let bank_data = {
      type: bankDataType,
      legal_name: legalName,
      bank_account: influencerAccountNumber,
      ifsc: influencerIfscCode,
      pan_number: influencerPanNumber,
    };
    let upi_data = {
      type: bankDataType,
      upi_id: upiId,
      legal_name: legalName,
      pan_number: influencerPanNumber,
    };
    let address_data = {
      premise: influencerPremise,
      city: influencerCity,
      state: influencerState,
      pincode: influencerPincode,
    };
    let influencer_data = {
      influencer_phone: influencerPhoneNumber,
    };

    let params = {
      influencer_id: influencerId,
      bank_data:
        bankDataType == "bank"
          ? JSON.stringify(bank_data)
          : JSON.stringify(upi_data),
      address_data: JSON.stringify(address_data),
    };
    if (influencerPhoneNumber !== null && !influencerPhone) {
      params.influencer_data = JSON.stringify(influencer_data);
    }
    Core.verifyKycAuto(
      verifyKycAutoSuccess,
      verifyKycAutoFailed,
      (status) => setUpdateKycLoading(status),
      params,
    );
  }

  function verifyKycAutoSuccess(response_data) {
    if (response_data && !response_data.err_l) {
      openSnackbar("KYC verified successfully");
      setInfluencerKycPopupOpen(false);
      startAssignment(influencerId, assignmentId);
    } else if (response_data && response_data.err_l) {
      // Handle errors that come back with 200 status but contain error details
      verifyKycAutoFailed(response_data.err_l);
    }
  }

  function verifyKycAutoFailed(errorList) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
  }

  // function getGenerateShareKeyCampaignContractsList() {
  //   var params = {
  //     campaign_id: campaignId,
  //   };

  //   Core.getGenerateShareKeyCampaignContractsList(
  //     getGenerateShareKeyCampaignContractsListSuccess,
  //     getGenerateShareKeyCampaignContractsListFailed,
  //     () => {},
  //     params
  //   );
  // }

  // function getGenerateShareKeyCampaignContractsListSuccess(response_data) {}

  // function getGenerateShareKeyCampaignContractsListFailed(errorList) {
  //   openSnackbar(errorList.map((err) => err.m).join(", "));
  // }

  function navigateToAssignmentDetails(assignmentId) {
    navigate(`/contractDetail/${assignmentId}`);
  }

  function SortDropDown() {
    if (filterDropDown) {
      setFilterDropDown(false);
    } else {
      setFilterDropDown(true);
    }
  }

  function filterDropDownOpenClose() {
    if (filterStatus != "ALL") {
      setFilterLabel(null);
      setFilterStatus("ALL");
    } else {
      SortDropDown();
    }
  }
  // const customStyles = {
  //   rows: {
  //     style: {
  //       background: "#1C1835",
  //       fontSize: "16px",
  //       color: "#ECEBF6",
  //       paddingTop: "20px",
  //       borderBottom: ".5px solid #54545f",
  //     },
  //   },

  //   headCells: {
  //     style: {
  //       background: "#1C1835",
  //       fontSize: "15px",
  //       color: "#A6A5B4",
  //       paddingTop: "26px",
  //       paddingBottom: "26px",
  //       minWidth: "150px !important",
  //       // borderBottom: ".5px solid ##424158",
  //       border: "none !important",
  //     },
  //   },
  //   cells: {
  //     style: {
  //       borderBottom: ".5px solid #54545f",
  //       paddingBottom: "26px",
  //       minWidth: "120px !important",
  //     },
  //   },
  // };

  // let completedAssignment = 0;

  // let totalAssignment;

  // function getDataDeliverables(contents_deep_data) {
  //   totalAssignment = Object.keys(contents_deep_data).length;

  //   Object.keys(contents_deep_data).map((item) => {
  //     const { status } = contents_deep_data[item].content_data;
  //     if (status == "COMPLETED") {
  //       completedAssignment++;
  //     }

  //     return (
  //       completedAssignment +
  //       " " +
  //       "out of " +
  //       totalAssignment +
  //       " images ready to review"
  //     );
  //   });
  //   return (
  //     completedAssignment +
  //     " out of " +
  //     totalAssignment +
  //     " images ready to review"
  //   );
  // }

  const AssignmentCSV = () => {
    const data = assignmentList.map((item) => {
      let content_data;
      if (item.assignment_data.type === "social_media") {
        content_data = Utils.constructContentMediaUrl(
          item.assignment_data.assignment_id,
          Object.values(item.contents_deep_data)[0].content_data.media_id,
        );
      } else {
        content_data = "";
      }

      return {
        "Contract ID": item.assignment_data.assignment_id,
        "Influencer Name": item.influencer_data.name,
        "Contract Amount": item.reward_data.value.amount,
        "Content Status": Utils.generateAssignmentSubText(item),
        "Contract Status": Utils.assignmentStatusToString(
          item.assignment_data.assignment_status,
        ),
        "Contract Date": Utils.convertUnixToDate(
          item.assignment_data.date_added,
        ),
        "Delivery Date": Utils.convertUnixToDate(
          item.assignment_data.delivery_date,
        ),
        "Social URL": Object.values(item.contents_deep_data)[0].content_data
          .url,
        "Content URL": content_data,
      };
    });

    return (
      <div className="bid-csv-btn" onClick={() => exportToCSV(data)} style={{}}>
        <Icon iconName="downloadIcon" />
      </div>
    );
  };

  const tableSchema = [
    {
      name: "Influencer Name",
      selector: (row) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Image
            fallBack={require("../../resources/images/fallback.png")}
            source={
              row.influencer_data.profile_picture
                ? Utils.generateInfluencerDpUrl(
                    row.influencer_data.influencer_id,
                    row.influencer_data.profile_picture,
                  )
                : require("../../resources/images/fallback.png")
            }
            className="table-profile"
          />
          <div className="influencer-table-profile">
            {" "}
            {row.influencer_data.name}
          </div>
        </div>
      ),
    },

    {
      name: props?.isBrand ? "Rewards" : "Influencer Reward",
      selector: (row) => {
        const amount = Number(row?.reward_data?.value?.amount || 0);
        const clientPrice = Number(row?.assignment_data?.client_price || 0);

        // Brand view
        if (props.isBrand) {
          return clientPrice > 0 ? `Rs ${clientPrice}` : "-";
        }

        // Influencer view
        return amount === 0 ? "_" : `Rs ${amount}`;
      },
    },

    {
      name: "Deliverables",
      selector: (row) => {
        return Utils.generateAssignmentSubText(row);
      },
    },

    {
      name: "Status",
      selector: (row) => {
        return Utils.assignmentStatusToString(
          row["assignment_data"]["assignment_status"],
        );
      },
      cell: (data) => (
        <span
          style={{
            color: statusColors[data.assignment_data.assignment_status],
          }}
          // onClick={(e) => {
          //   CampaignClick(data.campaign_data.campaign_id);
          //   e.stopPropagation();
          // }}
        >
          {Utils.assignmentStatusToString(
            data.assignment_data.assignment_status,
          )}
        </span>
      ),
    },
  ];

  if (!props.isBrand) {
    tableSchema.push({
      name: "",
      maxWidth: "200px",
      cell: (data) =>
        data?.assignment_data?.assignment_status == "ACTIVE" && (
          <span>
            <PrimaryCta
              fifth
              text="Start Contract"
              isLoading={startAssignmentLoading}
              onClick={() => {
                const currentInfluencerId =
                  data?.influencer_data?.influencer_id;
                const currentAssignmentId =
                  data?.assignment_data?.assignment_id;
                const currentPhoneNumber = data?.influencer_data?.phone;

                if (data?.influencer_data?.is_influencer_kyc_complete !== "1") {
                  // Set state for KYC popup
                  setInfluencerId(currentInfluencerId);
                  setAssignmentId(currentAssignmentId);
                  setInfluencerPhone(currentPhoneNumber);
                  setInfluencerKycPopupOpen(true);
                } else {
                  // Call startAssignment with current values
                  startAssignment(currentInfluencerId, currentAssignmentId);
                }
              }}
            />
          </span>
        ),
    });
  }

  // Table CSS

  const customStyle = {
    headRow: {
      style: {
        backgroundColor: "var(--general-secondary-color)", // Change header background color
        color: "var(--gray-gray-300)", // Change header text color
        fontSize: "16px",
        fontWeight: 600,
        lineHight: "19.2px",
        border: "none",
      },
    },
    headCells: {
      style: {
        padding: "10px 0px 10px 20px",
      },
    },
    rows: {
      style: {
        cursor: "pointer",
        fontSize: "16px",
        fontWeight: 400,
        lineHight: "19.2px",
        "&:hover": {
          backgroundColor: "var(--general-secondary-color)",
          fontWeight: 600,
        },
      },
    },
    cells: {
      style: {
        paddingLeft: "20px",
      },
    },
  };

  return (
    <div style={{ minHeight: 500 }}>
      {isLoading ? (
        <div className="loader-mid">
          <Loader />
        </div>
      ) : (
        <>
          <div className="bid-list-dropdown-header-container-new">
            {assignmentList.length !== 0 && (
              <div className="cursor-pointer" onClick={openModalShare}>
                {" "}
                <Icon iconName="shareIcons" />
              </div>
            )}

            <div className="dropdown-button-container">
              <button
                onClick={() => filterDropDownOpenClose()}
                className="dropdown-button"
              >
                <CustomText
                  p
                  text={filterLabel ? filterLabel : "ALL"}
                  fontSize={"font_size_regular"}
                  textColor={"text_color_black"}
                  textAlign={"text_align_right"}
                />
                {filterLabel ? (
                  <div className="cursor-pointer">
                    <Image
                      source={require("../../resources/images/bid-search-cross.png")}
                    />
                  </div>
                ) : (
                  <div className="cursor-pointer">
                    <Icon iconName={"DropdownIcon"} height={18} width={18} />
                  </div>
                )}
              </button>
              {filterDropDown && (
                <div className="dropdown-list-container-contract">
                  {sortTypes.map((item) => {
                    return (
                      <div
                        onClick={() => {
                          setNext(0);
                          setFilterStatus(item.Status);
                          SortDropDown();
                          setFilterLabel(item.label);
                        }}
                        className={
                          item.Status == filterStatus
                            ? "dropdown-button-list-selected"
                            : "dropdown-button-list"
                        }
                      >
                        {item.label}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div>
              <AssignmentCSV />
            </div>
          </div>

          <div className="custom-table-new">
            {/*      
      <InfluencerListDropdownNew
              dropdownItems={campaignStatusList}
              onItemClick={(item) => {
                setNext(0);
                setFilterStatus(item);
              }}
            /> */}

            <div className="table-contract">
              <CustomTable
                className="CustomTable"
                tableSchema={tableSchema}
                tableData={assignmentList}
                rowPaddingTop={16}
                paginationPerPage={15}
                rowPaddingBottom={16}
                customStyles={customStyle}
                onRowClicked={(item) =>
                  navigateToAssignmentDetails(
                    item.assignment_data.assignment_id,
                  )
                }
                pagination
              />
            </div>
          </div>
        </>
      )}
      {}
      {modalIsOpenShare && (
        <InfluencerContractsShareLink
          closeShareModal={closeShareModal}
          campaignId={campaignId}
          assignment_share_key={assignment_share_key}
          // shareKey={
          //   influencerContractsList.length > 0 &&
          //   influencerContractsList[0]?.collection_data?.share_key
          // }
        />
      )}
      {influencerKycPopupOpen && (
        <EmptyPopup
          onClose={() => setInfluencerKycPopupOpen(false)}
          width="768px"
          title={"Please complete KYC of Influencer"}
          children={
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ overflowY: "auto" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflowY: "auto",
                    gap: 20,
                  }}
                >
                  {!influencerPhone && (
                    <div>
                      <div className="m-b-6">
                        <CustomText
                          p
                          text="Phone Number"
                          className="typographyMedium"
                        />
                      </div>
                      <CustomTextInput
                        value={influencerPhoneNumber}
                        type="number"
                        onChange={(e) =>
                          setInfluencerPhoneNumber(
                            e.target.value.replace(/[^0-9]/g, "").slice(0, 10),
                          )
                        }
                        placeholder="Enter 10 digit Phone Number"
                        maxLength={10}
                        padding="8px"
                      />
                    </div>
                  )}

                  <div>
                    <div className="m-b-6">
                      <CustomText
                        p
                        text="Enter name on PAN"
                        className="typographyMedium"
                      />
                    </div>
                    <CustomTextInput
                      value={legalName}
                      onChange={(e) => setLegalName(e.target.value)}
                      placeholder="Enter name on PAN"
                      padding="8px"
                    />
                  </div>
                  <div>
                    <div className="m-b-6">
                      <CustomText
                        p
                        text="PAN Number"
                        className="typographyMedium"
                      />
                    </div>
                    <CustomTextInput
                      value={influencerPanNumber}
                      onChange={(e) =>
                        setInfluencerPanNumber(e.target.value.toUpperCase())
                      }
                      placeholder="Enter PAN Number"
                      maxLength={10}
                      padding="8px"
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: 20,
                    }}
                  >
                    {/* UPI */}
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        name="paymentType"
                        value="upi"
                        checked={bankDataType == "upi"}
                        onChange={() => setBankDataType("upi")}
                      />
                      <span>UPI</span>
                    </label>

                    {/* Bank */}
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        name="paymentType"
                        value="bank"
                        checked={bankDataType == "bank"}
                        onChange={() => setBankDataType("bank")}
                      />
                      <span>Bank Account</span>
                    </label>
                  </div>

                  {bankDataType == "upi" && (
                    <div>
                      <div>
                        <div className="m-b-6">
                          <CustomText
                            p
                            text="UPI ID"
                            className="typographyMedium"
                          />
                        </div>
                        <CustomTextInput
                          value={upiId}
                          onChange={(e) => setUpiId(e.target.value)}
                          placeholder="Enter UPI ID"
                          padding="8px"
                        />
                      </div>
                    </div>
                  )}

                  {bankDataType == "bank" && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 20,
                      }}
                    >
                      <div>
                        <div className="m-b-6">
                          <CustomText
                            p
                            text="Account Number"
                            className="typographyMedium"
                          />
                        </div>
                        <CustomTextInput
                          value={influencerAccountNumber}
                          onChange={(e) =>
                            setInfluencerAccountNumber(e.target.value)
                          }
                          placeholder="Enter Account Number"
                          padding="8px"
                        />
                      </div>

                      <div>
                        <div className="m-b-6">
                          <CustomText
                            p
                            text="Confirm Account Number"
                            className="typographyMedium"
                          />
                        </div>
                        <CustomTextInput
                          value={influencerConfirmAccountNumber}
                          onChange={(e) =>
                            setInfluencerConfirmAccountNumber(e.target.value)
                          }
                          placeholder="Re-enter Account Number"
                          padding="8px"
                        />
                      </div>

                      <div>
                        <div className="m-b-6">
                          <CustomText
                            p
                            text="IFSC Code"
                            className="typographyMedium"
                          />
                        </div>
                        <CustomTextInput
                          value={influencerIfscCode}
                          onChange={(e) =>
                            setInfluencerIfscCode(e.target.value.toUpperCase())
                          }
                          placeholder="Enter IFSC Code"
                          maxLength={11}
                          padding="8px"
                        />
                      </div>
                    </div>
                  )}

                  <div>
                    <div className="m-b-6">
                      <CustomText
                        p
                        text="Premise"
                        className="typographyMedium"
                      />
                    </div>
                    <CustomTextInput
                      value={influencerPremise || ""}
                      onChange={(e) => setInfluencerPremise(e.target.value)}
                      placeholder="Enter Premise"
                      padding="8px"
                    />
                  </div>

                  <div>
                    <div className="m-b-6">
                      <CustomText p text="City" className="typographyMedium" />
                    </div>
                    <Select
                      multi={false}
                      options={CampaignData.CITY.filter(
                        (c) => c.type == "city",
                      )}
                      values={CampaignData.CITY.filter(
                        (c) =>
                          c.type == "city" && c.id == Number(influencerCity),
                      )}
                      onChange={(selectedList) => {
                        if (selectedList && selectedList[0]) {
                          setInfluencerCity(selectedList[0].id);
                        } else {
                          setInfluencerCity("");
                        }
                      }}
                      placeholder="Select City"
                      autoFocus={false}
                      color="#C8C2C2"
                      labelField="label"
                      valueField="id"
                      style={{
                        border: "1px solid #cbd2d9",
                        backgroundColor: "#fff",
                        borderRadius: 6,
                        padding: "6px",
                      }}
                    />
                  </div>

                  <div>
                    <div className="m-b-6">
                      <CustomText p text="State" className="typographyMedium" />
                    </div>
                    <Select
                      multi={false}
                      options={Object.values(CampaignData.LOCATIONS)}
                      values={Utils.getSelectedStateObjects([
                        influencerState,
                      ]).filter(Boolean)}
                      onChange={(selectedList) => {
                        if (selectedList && selectedList[0]) {
                          setInfluencerState(selectedList[0].id);
                        } else {
                          setInfluencerState("");
                        }
                      }}
                      placeholder="Select State"
                      autoFocus={false}
                      color="#C8C2C2"
                      labelField="n"
                      valueField="id"
                      style={{
                        border: "1px solid #cbd2d9",
                        backgroundColor: "#fff",
                        borderRadius: 6,
                        padding: "6px",
                      }}
                    />
                  </div>

                  <div>
                    <div className="m-b-6">
                      <CustomText
                        p
                        text="Pincode"
                        className="typographyMedium"
                      />
                    </div>
                    <CustomTextInput
                      value={influencerPincode || ""}
                      onChange={(e) =>
                        setInfluencerPincode(
                          e.target.value.replace(/[^0-9]/g, "").slice(0, 6),
                        )
                      }
                      placeholder="Enter Pincode"
                      padding="8px"
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: 10,
                    }}
                  >
                    <PrimaryCta
                      fifth
                      text="Submit KYC"
                      isLoading={updateKycLoading}
                      onClick={() => {
                        if (!validateKycForm()) return;
                        verifyKycAuto();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          }
        />
      )}

      {/* <div className="custom-table">
    <CustomTable
      className="CustomTable"
      tableSchema={tableSchema}
      tableData={assignmentList}
      rowPaddingTop={16}
      paginationPerPage={15}
      rowPaddingBottom={16}
      customStyles={customStyle}
      onRowClicked={(item) =>
        navigateToAssignmentDetails(
          item.assignment_data.assignment_id
        )
      }
      pagination
    />
  </div> */}
    </div>
  );

  // const columns = [
  //   {
  //     name: "Campaign Name",
  //     selector: (row) => row.assignment_data.name,
  //   },
  //   {
  //     name: "Creator Name",
  //     selector: (row) => (
  //       <div style={{ display: "flex", alignItems: "center" }}>
  //         <Image
  //           fallBack={require("../../resources/images/fallback.png")}
  //           source={
  //             row.influencer_data.profile_picture
  //               ? Utils.generateInfluencerDpUrl(
  //                   row.influencer_data.influencer_id,
  //                   row.influencer_data.profile_picture
  //                 )
  //               : require("../../resources/images/fallback.png")
  //           }
  //           className="table-profile"
  //         />
  //         <div className="influencer-table-profile">
  //           {" "}
  //           {row.influencer_data.name}
  //         </div>
  //       </div>
  //     ),
  //   },
  //   {
  //     name: "Amount",
  //     selector: (row) => row.reward_data.value.amount,
  //   },
  //   {
  //     name: "Deliverables",
  //     selector: (row) => getDataDeliverables(row.contents_deep_data),
  //   },
  //   {
  //     name: "Status",
  //     selector: (row) => row.assignment_data.assignment_status,
  //     conditionalCellStyles: [
  //       {
  //         when: (row) => row.assignment_data.assignment_status === "ACTIVE",
  //         style: Style.text_active_color,
  //       },
  //       {
  //         when: (row) =>
  //           row.assignment_data.assignment_status === "PAYMENT_PENDING",
  //         style: Style.text_completed_color,
  //       },
  //       {
  //         when: (row) => row.assignment_data.assignment_status === "COMPLETED",
  //         style: Style.text_completed_color,
  //       },
  //       {
  //         when: (row) => row.assignment_data.assignment_status === "CANCELLED",

  //         style: Style.text_pending_color,
  //       },
  //       {
  //         when: (row) =>
  //           row.assignment_data.assignment_status === "IN_PROGRESS",
  //         style: Style.text_active_color,
  //       },
  //     ],
  //   },
  // ];

  // return (
  //   <div style={{ minHeight: 500 }}>
  //     {isLoading ? (
  //       <div className="fall-back-center-campaign">
  //         <Loader />
  //       </div>
  //     ) : (
  //       <>
  //         {assignmentList && assignmentList.length !== 0 ? (
  //           <InfiniteScroll
  //             dataLength={assignmentList.length}
  //             next={() => getAssignmentUser(next, updateProgress)}
  //             hasMore={next !== null}
  //             loader={<h4>loading...</h4>}>
  //             <div className="contract-table-list">
  //               {assignmentList.map((row) => (
  //                 <AssignmentList
  //                   className="campaign-list-contract"
  //                   onClick={() =>
  //                     navigateToAssignmentDetails(
  //                       row.assignment_data.assignment_id
  //                     )
  //                   }
  //                   source={
  //                     row.influencer_data.profile_picture
  //                       ? Utils.generateInfluencerDpUrl(
  //                           row.influencer_data.influencer_id,
  //                           row.influencer_data.profile_picture
  //                         )
  //                       : require("../../resources/images/fallback.png")
  //                   }
  //                   influencerName={row.influencer_data.name}
  //                   rewardText={Utils.formatRewardText(row.reward_data)}
  //                   deliverablesText={Utils.generateAssignmentSubText(row)}
  //                   status={Utils.assignmentStatusToString(
  //                     row.assignment_data.assignment_status
  //                   )}
  //                 />
  //               ))}
  //             </div>
  //           </InfiniteScroll>
  //         ) : (
  //           <div className="fall-back-center-campaign">
  //             <FallBack
  //               heading={"No Contracts Available"}
  //               title={"Explore more and short out some items"}
  //               // subTitle={"elit, sed do eiusmod tempor incididunt. ipasum"}
  //             />
  //           </div>
  //         )}
  //       </>
  //     )}
  //   </div>
  // );
}

export default AssignmentListScreen;
